import { flexRender } from "@tanstack/react-table";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import DataService from "../../../../../Service";
import moment from "moment";
import { DateFormatter } from "../../../../../Common/Utils/common_utils";
const ms = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const staticValueFinder = (componentType, cell, customComponentKey) => {
  const value = cell.getValue();
  switch (componentType) {
    case "text":
      return value;
    case "datePicker":
      return value;
    case "dropdown":
      if (typeof value === "string") {
        return value;
      }
      return value?.value;
    case "multiSelect":
      console.log(typeof value, value, "multiselect");
      if (Array.isArray(value)) {
        return value?.map((el) => el.value).join(" , ");
      } else {
        return "";
      }
    case "action":
      return flexRender(cell.column.columnDef.cell, cell.getContext());
    case "dropdown_predictive":
      if (typeof value === "string") {
        return value;
      }
      return value?.value;
    case "uploadFiles":
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          {" "}
          {value?.map((el, ind) => {
            return (
              <a
                target="_blank"
                href={el?.value?.url || el?.value}
                rel="noreferrer"
              >
                {" "}
                {ind + 1}{" "}
              </a>
            );
          })}
        </div>
      );
    case "fiscalYear":
      if (!(value?.from_month || value?.to_month)) {
        return "-";
      } else {
        let fromDateString = value?.from_month;
        let toDateString = value?.to_month;
        if (value?.from_month.length < 11 || value?.to_month.length < 11) {
          fromDateString = moment(
            value?.from_month,
            "DD-MM-YYYY"
          ).toISOString();
          toDateString = moment(value?.to_month, "DD-MM-YYYY").toISOString();
        }
        console.log(fromDateString, toDateString, "to from");
        const fromMonth = new Date(fromDateString).getMonth();
        const toMonth = new Date(toDateString).getMonth();
        return `${ms[fromMonth] || ""} to ${ms[toMonth] || ""} `;
      }
    case "customComponent":
      switch (customComponentKey) {
        case "incomePerYear":
          if (value && value?.length > 0) {
            return value
              ?.map((el) => el.income.toString() + "-" + el.year.toString())
              .join(",");
          } else {
            return "-";
          }
        case "magicFields":
          const keys = Object.keys(value || {});
          if (keys.length > 0) {
            return keys
              ?.map((el) => {
                return el + "-" + value[el].join(",");
              })
              ?.join(",");
          } else {
            return "-";
          }
        case "orgAddress":
          let addressValue = {};
          if (Array.isArray(value)) {
            addressValue = value[0];
          } else {
            addressValue = value;
          }
          if (
            addressValue?.business_address &&
            addressValue.city &&
            addressValue?.address_line1
          ) {
            return (
              addressValue?.business_address +
              "," +
              addressValue.address_line1 +
              "," +
              addressValue?.city
            );
          } else {
            return "-";
          }
        case "dueDiligenceDetails":
          if (value && value?.length > 0) {
            return value
              ?.map((el) => {
                return el.available_date;
              })
              .join(",");
          } else {
            return "-";
          }
        default:
          return "-";
      }

    default:
      return "will render something else sooner";
  }
};
export const postDataFormatter = (rawData, columns) => {
  let formattedData = [];
  console.log(rawData, "raw data");
  for (let i in rawData) {
    const specificColumn = columns.find((el) => el.id === i);
    const { componentType, optionsKey } = specificColumn.columnDef;
    switch (componentType) {
      case "text":
      case "datePicker":
        formattedData.push({
          field_value: `${rawData[i]}`,
          field_type: `${i}`,
        });
        break;
      case "dropdown":
      case "dropdown_predictive":
        if (
          optionsKey === "yes_or_no" ||
          optionsKey === "only_yes_or_no" ||
          optionsKey === "only_true_or_false" ||
          i === "OrganisationProfile_opportunities" ||
          i === "OrganisationProfile_priority_criteria" ||
          i === "Organisation_level_structure"
        ) {
          formattedData.push({
            field_value: `${rawData[i]?.id}`,
            field_type: `${i}`,
          });
        } else {
          formattedData.push({
            drop_down_value: [`${rawData[i]?.id}`],
            field_type: i,
          });
        }
        break;
      case "multiSelect":
        formattedData.push({
          drop_down_value: rawData[i]?.map((el) => el.id),
          field_type: `${i}`,
        });
        break;
      case "fiscalYear":
        const formattedFromMonth = moment(rawData[i]?.from_month).format(
          "DD-MM-YYYY"
        );
        const formattedToMonth = moment(rawData[i]?.to_month).format(
          "DD-MM-YYYY"
        );
        formattedData.push({
          drop_down_value: [
            { from_month: formattedFromMonth, to_month: formattedToMonth },
          ],
          field_type: `${i}`,
        });
        break;
      case "customComponent":
        formattedData.push({
          drop_down_value: rawData[i],
          field_type: `${i}`,
        });
        break;

      default:
        formattedData.push({
          field_value: rawData[i],
          field_type: `${i}`,
        });
    }
  }
  return formattedData;
};

export const mandatoryFieldsErrorDispatcher = (
  table,
  dispatch,
  notFilledMandatoryFields
) => {
  const correspondingKeys = {};
  table.getAllLeafColumns().forEach((el) => {
    const columns = el.columnDef;
    correspondingKeys[columns.id] = columns.header;
  });
  dispatch(
    showSnackbar(
      "error",
      [
        `Please fill these fields - ${notFilledMandatoryFields
          ?.map((cur) => correspondingKeys[cur] || "")
          .join(",")}`,
      ],
      2000
    )
  );
};

export const errorDispatcher = (
  table,
  dispatch,
  noProperInputFields,
  notFilledMandatoryFields
) => {
  const correspondingKeys = {};
  table.getAllLeafColumns().forEach((el) => {
    const columns = el.columnDef;
    correspondingKeys[columns.id] = columns.header;
  });
  const errorMessages = [];

  if (noProperInputFields.length > 0) {
    errorMessages.push(
      `Please give proper inputs for these fields - ${noProperInputFields
        ?.map((cur) => correspondingKeys[cur] || "")
        .join(",")}`
    );
  }
  if (notFilledMandatoryFields.length > 0) {
    errorMessages.push(
      `Please fill these fields - ${notFilledMandatoryFields
        ?.map((cur) => correspondingKeys[cur] || "")
        .join(",")}`
    );
  }

  if (errorMessages.length > 0) {
    dispatch(showSnackbar("error", errorMessages, 2000));
  }
};

export const properInputFieldsErrorDispatcher = (
  table,
  dispatch,
  noProperInputFields
) => {
  const correspondingKeys = {};
  table.getAllLeafColumns().forEach((el) => {
    const columns = el.columnDef;
    correspondingKeys[columns.id] = columns.header;
  });
  dispatch(
    showSnackbar(
      "error",
      [
        `Please give proper inputs for these fields - ${noProperInputFields
          ?.map((cur) => correspondingKeys[cur] || "")
          .join(",")}`,
      ],
      2000
    )
  );
};

export const additionalDropdowns = {
  yes_or_no: [
    { id: "Yes", value: "Yes", name: "yes" },
    { id: "No", value: "No", name: "No" },
    {
      id: "Not known yet",
      value: "Not known yet",
      name: "Not known yet",
    },
  ],
  only_yes_or_no: [
    { id: "Yes", value: "Yes", name: "Yes" },
    { id: "No", value: "No", name: "No" },
  ],
  only_true_or_false: [
    { id: true, value: "Yes", name: "Yes" },
    { id: false, value: "No", name: "No" },
  ],
};
export const getDropdowns = (liveViewType, orgId) => {
  const listingSetup = {
    organisation: {
      params: { organisation_id: orgId },
      key: "all_organisation_dropdowns",
    },
    partner: {
      key: "partner_profiles",
      params: { partner_id: orgId },
    },
  };

  const { params, key } = listingSetup[liveViewType];

  return DataService.getData(params, key);
};
